import { render, staticRenderFns } from "./AProject.vue?vue&type=template&id=61f6cdb6&scoped=true"
import script from "./AProject.vue?vue&type=script&lang=js"
export * from "./AProject.vue?vue&type=script&lang=js"
import style0 from "./AProject.vue?vue&type=style&index=0&id=61f6cdb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f6cdb6",
  null
  
)

export default component.exports